import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import userService from '../../api/userService'; 
import './Login.css';
import logo from '../../assets/Logo/vps infrastructure logo.png';

const Login = () => {
  const navigate = useNavigate();
  
  const [credentials, setCredentials] = useState({
    email: '',
    password: '',
    role: '' 
  });
  const [error, setError] = useState('');

  const handleChange = (e) => {
    setCredentials({ ...credentials, [e.target.name]: e.target.value });
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');

    if (!credentials.role) {
      setError("Please select a role before logging in.");
      return;
    }

    try {
      const response = await userService.login({
        email: credentials.email,
        password: credentials.password,
        role: credentials.role
      });
      
      // Based on your JSON structure: response.data.user
      if (response.success) {
        // Store user details for the Sidebar
        localStorage.setItem('token', response.token || ''); 
        localStorage.setItem('userRole', response.data.role); // 'admin'
        localStorage.setItem('userName', response.data.user.name); // 'Vps Infrastructures'
        localStorage.setItem('userEmail', response.data.user.email); // 'vpsinfrastructures@gmail.com'
        
        navigate('/dashboard');
      }
    } catch (err) {
      setError(err.message || "Invalid email or password.");
    }
  };

  return (
    <div className="admin-login-container">
      <div className="login-box shadow-lg">
        <div className="login-left">
          <div className="illustration-wrapper">
            <div className="login-brand-header">
              <img src={logo} alt="VPS Infrastructure" className="admin-login-logo" />
            </div>
          </div>
          <p className="login-tagline">Login your Account to get full User Experience</p>
          <span className="premium-tip">Tip: Upgrade your Account to get access Premium Features</span>
        </div>

        <div className="login-right">
          <div className="form-content">
            <header className="mb-4">
              <h4 className="text-secondary mb-0">Hello!</h4>
              <h2 className="fw-bold">Good Morning</h2>
            </header>

            <form onSubmit={handleLogin} className="form-group-wrapper">
              <h5 className="login-subtitle">Login your account</h5>
              
              <div className="custom-input-group mt-4">
                <label>Email Address</label>
                <input 
                  type="email" 
                  name="email" 
                  className="form-control-custom" 
                  placeholder="name@example.com"
                  onChange={handleChange} 
                  required 
                />
              </div>

              <div className="custom-input-group mt-3">
                <label>Password</label>
                <input 
                  type="password" 
                  name="password" 
                  className="form-control-custom" 
                  placeholder="••••••••"
                  onChange={handleChange} 
                  required 
                />
              </div>

              <div className="text-end mt-2">
                <a href="#!" className="forgot-link">forget password?</a>
              </div>

              <div className="role-selection mt-4 p-2" style={{ background: '#f8f9fa', borderRadius: '8px' }}>
                <label className="small fw-bold text-secondary d-block mb-2">Login as:</label>
                <div className="d-flex gap-4">
                  <label className="d-flex align-items-center gap-2" style={{ cursor: 'pointer' }}>
                    <input type="radio" name="role" value="admin" onChange={handleChange} /> 
                    <span className="small">Admin</span>
                  </label>
                  <label className="d-flex align-items-center gap-2" style={{ cursor: 'pointer' }}>
                    <input type="radio" name="role" value="staff" onChange={handleChange} /> 
                    <span className="small">Staff</span>
                  </label>
                </div>
              </div>

              <button type="submit" className="btn-login-main mt-4">Login</button>
              
              {error && (
                <div className="alert alert-danger mt-3 py-2 px-3 small d-flex align-items-center">
                  <i className="bi bi-exclamation-triangle-fill me-2"></i>
                  {error}
                </div>
              )}
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;